// based on https://stackoverflow.com/a/13501027/15563490

export default function paginateMessage(message, testElement, pixelWidth) {
	if (message.length <= 0)
		return [];

	const splitData = message.split(/([\s\n\r]+)/);
	const arr = [];
	let cnt = 0;
	for (let i = 0; i < splitData.length; ++i) {
		if (!arr[cnt]) arr[cnt] = '';  //Instantiate array entry to empty string if null or undefined

		testElement.text(arr[cnt]);
		if (testElement.width() > pixelWidth) {
			cnt++;
		}

		if (!arr[cnt]) arr[cnt] = '';
		arr[cnt] += splitData[i];
	}

	return arr;
}
